'use strict';
{
    var app = angular.module('tf.settings', [])
        .controller('settingsCtrl', ['$scope', '$state', '$stateParams', 'userConfig', '$http', 'confirmationService', 'userService', 'currentUserService', function ($scope, $state, $stateParams, userConfig, $http, confirmationService, userService, currentUserService) {
            $scope.userConfig = userConfig;

            $scope.confirmationSettings = confirmationService.confirmationSettings();

            $scope.changePasswordDetails = {
                currentPassword : null,
                newPassword : null,
                confirmPassword : null,
                strength : 0,
                error : undefined,
                success : false
            };

            const profile = userConfig.profile;
            let givenName;
            let surname;

            if (profile != null) {
                givenName = profile.givenName;
                surname = profile.surname;
            }

            $scope.changeUserDetails = {
                name: userConfig.shortName,
                email: userConfig.username,
                givenName,
                surname
            };

            $scope.email = {
                open : $state.params.setting === 'email'
            };

            $scope.name = {
                open : $state.params.setting === 'name'
            };

            $scope.alias = {
                open : $state.params.setting === 'alias'
            };

            $scope.password = {
                open : $state.params.setting === 'password'
            };

            $scope.changeEmail = function() {
                if(!currentUserService.isOauthAuthenticated()){
                    $http.post('/tradefloor/api/user/email', $scope.changeUserDetails.email).then(function(response){
                        var data = response.data;
                        userConfig.username = $scope.changeUserDetails.email;
                        $scope.changeUserDetails = {
                            name: null,
                            email: null
                        };
                        $scope.email.open = false;
                        userConfig.pendingEmailChange = data;
                    })
                }else{
                    window.open(userConfig.securitySetting, "_blank");
                }

            };

            $scope.changeName = function() {
                $http.post('/tradefloor/api/user/name', $scope.changeUserDetails.name).then(function(){
                    userConfig.shortName = $scope.changeUserDetails.name;
                    $scope.changeUserDetails = {
                        name: null,
                        email: null,
                        alias: null
                    };
                    $scope.name.open = false;
                })
            };

            $scope.updateFullName = () => {
                const givenName = $scope.changeUserDetails.givenName;
                const surname = $scope.changeUserDetails.surname;
                userService.updateFullName(givenName, surname);
            };

            $scope.changeAlias = function() {
                $http.post('/tradefloor/api/user/alias', $scope.changeUserDetails.alias).then(function(){
                    $scope.userConfig.alias = $scope.changeUserDetails.alias;
                    $scope.changeUserDetails = {
                        name: null,
                        email: null,
                        alias: null
                    };
                    $scope.alias.open = false;
                })
            };

            $scope.enableContextualHelp = function(enabled) {
                $http.post('/tradefloor/api/user/help', enabled).then(function () {
                    $scope.userConfig.contextHelp = enabled;
                });
            };

            $scope.changeConfirmation = function(setting) {
                confirmationService.doNotShow(setting.confirmationType, !setting.show);
            };

            $scope.changePassword = function(form) {
                $http.put('/tradefloor/api/user/password', {currentPassword : $scope.changePasswordDetails.currentPassword, newPassword : $scope.changePasswordDetails.newPassword}).then(
                    function (response) {
                        $scope.changePasswordDetails.success = response.data;

                        if (!$scope.changePasswordDetails.success) {
                            $scope.changePasswordDetails.error = 'Failed to change password. Check your current password is correct.';
                        } else {
                            $scope.changePasswordDetails.currentPassword = null;
                            $scope.changePasswordDetails.newPassword = null;
                            $scope.changePasswordDetails.confirmPassword = null;
                            $scope.changePasswordDetails.strength = 0;

                            form.$setSubmitted();
                            form.$setPristine();
                            form.$setUntouched();
                            $scope.changePasswordDetails.error = null;
                        }
                    });
            };

            $scope.changePasswordOauth = function() {
                window.open(userConfig.securitySetting, "_blank");
            };

            $scope.isOauth = currentUserService.isOauthAuthenticated();
        }])
        .directive("isStrongPassword", function() {
            return {
                restrict : 'A',
                require: 'ngModel',
                link : function (scope, el, attrs, ngModel) {
                    var strength = 0;

                    function checkStrength() {
                        ngModel.$setValidity('isStrongPassword', strength >= 60 );
                    }

                    scope.$watch(attrs.isStrongPassword, function(newValue) {
                        strength = newValue;
                        checkStrength();
                        ngModel.$validate();
                    });
                    ngModel.$parsers.unshift(function(viewValue) {
                        checkStrength();
                        return viewValue;
                    });
                }
            }
        })
        .directive("matchPassword", function() {
            return {
                restrict : 'A',
                require: 'ngModel',
                link : function (scope, el, attrs, ngModel) {

                    function checkLinkedValue(viewValue) {
                        var matchPassword = scope.$eval(attrs['matchPassword']);
                        ngModel.$setValidity('matchPassword', matchPassword == viewValue);
                        return viewValue;
                    }


                    scope.$watch(attrs.matchPassword, function(newValue) {
                        checkLinkedValue(ngModel.$viewValue);
                        ngModel.$validate();
                    });

                    ngModel.$parsers.unshift(checkLinkedValue);
                }
            }
        });
}



